<template>
  <div class="contenedor-difusion">
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Beneficios</h1>
        <div class="barra"></div>
      </div>
      <section class="contenedor-login">
        <div class="contenedor-difusion-imagen">
          <img src="@/assets/geetaji.jpg" alt="Geeta Iyengar">
        </div>
        <div class="contenedor-seminario">
          <h2 class="titulo_beneficios">Beneficios para asociados a la AAYI</h2>
          <ul class="lista_precios_seminario">
            <li>⚬ Descuento en eventos organizados por la AAYI</li>
            <li>⚬ Posibilidad de aplicar a una beca <sup>*</sup></li>
            <li>⚬ Facilidades de pago </li>
            <li>⚬ Descuento en la bibliografía publicada por la asociación</li>
            <li>⚬ Descuento en materiales didácticos (Kit completo de props para la práctica personal, foams con las medidas utilizadas en el RIMYI, remeras, buzos,cuaderno de notas)</li>
            <li>⚬ Participación evento anual SAMYOGA</li>
            <!-- <li>⚬ Descuentos en Materiales Didáctico
              <div>
                <p>Como socio/a de la AAYI, accedé a descuentos especiales en elementos esenciales para tu práctica y enseñanza:</p>
                <ul class="lista_precios_seminario">
                  <li>⚬ Kits de Yoga Iyengar (bolso, bloques, mantas y foam) </li>
                  <li>⚬ Props de alta calidad (foam con las medidas del Rimyi) </li>
                  <li>⚬ Indumentaria (remeras de las convenciones nacionales y de la AAYI) </li>
                  <li>⚬ Material bibliográfico (libros autorizados)</li>
                </ul>
              </div>
            </li> -->
          </ul>
          <h2 class="titulo_beneficios">Beneficios Exclusivos para Profesores Certificados</h2>
           <ul class="lista_precios_seminario">
            <li>⚬ Visibilidad y promoción</li>
            <li>⚬ Inclusión en el directorio oficial de la AAYI</li>
            <!-- <li>⚬ Difusión mensual de un boletín con las actividades, talleres y clases que desees publicar. Si te interesa difundir, ingresa <a
             href="https://docs.google.com/forms/d/e/1FAIpQLSeq6RTw9jXFfHy44ZX9sRsx4X3ZfTtJehp__KJREJsZuRo6lQ/viewform"
             target="_blank"
             class="link_beneficios"
             >
              aquí
            </a></li> -->
          </ul>
          <p><sup>*</sup> En los eventos que se otorguen becas por sorteo , podrán postularse únicamente profesores certificados o practicantes oficialmente inscriptos en mentoría que no hayan viajado a India. </p>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import store from './../store'
export default {
  name: 'Beneficios',
  components: {
  },
  data: function () {
    return {
      store
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>
<style>

</style>
